export const cleanup = (obj) => {
  let newObj =  {}
  for (const p of Object.getOwnPropertyNames(obj)) {
    switch (p) {
      case 'id':
      case 'gametype':
      case 'boardtype':
      case 'numplayers':
      case 'hostid':
        newObj[p] = parseInt(obj[p]);
        break;
      case 'premium':
        newObj[p] = !!parseInt(obj[p]);
        break;
      case 'rank':
      case 'invite': {
        newObj[p] = obj[p] === "TRUE";
        break;
      }
      default:
        newObj[p] = obj[p];
    }
  }
  return newObj;
};